module.exports = __webpack_public_path__ + "img/map_1791447357641_89800.bbbc8294.gif";